import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from '../app.component';
import { AuthGuard } from '../auth-guard.service';
import { ApplicationComponent } from '../application/application.component';
import { LandingComponent } from '../application/landing/landing.component';
import { BasicComponent } from '../application/basic/basic.component';
import { PersonalComponent } from '../application/personal/personal.component';
import { EmploymentComponent } from '../application/employment/employment.component';
import { ResidencyComponent } from '../application/residency/residency.component';
import { ApplicantComponent } from '../application/applicant/applicant.component';
import { BackgroundCheckComponent } from '../application/background-check/background-check.component';
import { PaymentComponent } from '../application/payment/payment.component';
import { DashboardComponent } from '../application/dashboard/dashboard.component';
import { DocumentsComponent } from '../application/documents/documents.component';
import { ApplicantsComponent } from '../application/applicants/applicants.component';
import { InvitationComponent } from '../application/invitation/invitation.component';
import { TourDashboardComponent } from '../prospect/tour-dashboard/tour-dashboard.component';
import { RentablesComponent } from '../application/rentables/rentables.component';
import { VerifastApplicationComponent } from '../application/verifast/verifast.component';

const applicationRoutes: Routes = [
  {
    path: 'application',
    component: ApplicationComponent,
    children: [
        {
            path: '',
            children: [
                {path: 'landing', component: LandingComponent},
                {path: 'basic', component: BasicComponent, canActivate: [AuthGuard]},
                {path: 'personal', component: PersonalComponent, canActivate: [AuthGuard]},
                {path: 'employment', component: EmploymentComponent, canActivate: [AuthGuard]},
                {path: 'verifast', component: VerifastApplicationComponent, canActivate: [AuthGuard]},
                {path: 'residency', component: ResidencyComponent, canActivate: [AuthGuard]},
                {path: 'applicant', component: ApplicantComponent, canActivate: [AuthGuard]},
                {path: 'background-check', component: BackgroundCheckComponent, canActivate: [AuthGuard]},
                {path: 'payment', component: PaymentComponent, canActivate: [AuthGuard]},
                {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
                {path: 'dashboard/:source', component: DashboardComponent, canActivate: [AuthGuard]},
                {path: 'dashboard/:source/:errmsg', component: DashboardComponent, canActivate: [AuthGuard]},
                {path: 'documents', component: DocumentsComponent, canActivate: [AuthGuard]},
                {path: 'applicants', component: ApplicantsComponent, canActivate: [AuthGuard]},
                {path: 'invitation', component: InvitationComponent, canActivate: [AuthGuard]},
                {path: 'rentables', component: RentablesComponent, canActivate: [AuthGuard]},
            ]
        }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forChild(applicationRoutes) ],
  exports: [ RouterModule ]
})
export class ApplicationRoutingModule {}
